import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant42() {
  const {
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const content = {
    ru: {
      title1: 'Сделаем сайт для вас бесплатно.',
      title2: `Обслуживание — ${price}/мес.`,
      sub: `Мы делаем сайт за свой счёт. Вы смотрите, просите правки, утверждаете. Когда всё нравится — платите ${price} в месяц за хостинг и поддержку. Не понравится — просто уходите. Без оплаты.`,
      cta: 'Оставить заявку'
    },
    ua: {
      title1: 'Зробимо сайт для вас безкоштовно.',
      title2: `Обслуговування — ${price}/міс.`,
      sub: `Ми робимо сайт за свій рахунок. Ви дивитеся, просите правки, затверджуєте. Коли все подобається — платите ${price} на місяць за хостинг та підтримку. Не сподобається — просто йдете. Без оплати.`,
      cta: 'Залишити заявку'
    },
    en: {
      title1: 'We build your website for free.',
      title2: `Maintenance — ${price}/mo.`,
      sub: `We build the site at our expense. You review, request edits, and approve. When you love it, you pay ${price}/month for hosting and support. Don't like it? Just walk away. No charge.`,
      cta: 'Submit request'
    }
  }[language] || content.ru;
  return <>
      <section className="relative w-full pt-28 pb-12 px-4 flex items-center justify-center min-h-screen" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-663">
        {/* Full Rounded Video Container */}
        <div className="relative w-full max-w-[96%] h-[85vh] rounded-[2.5rem] overflow-hidden shadow-2xl flex items-end justify-center pb-16" data-id="element-664">
          <video src="https://cdn.magicpatterns.com/uploads/vrXe21wkVqS62d5BzpZ9eJ/original-2de319f4767c5a0d4acf4f107b938504.mp4" autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-665" />

          {/* Bottom Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-black/10" data-id="element-666" />

          {/* Bottom-Centered Cinematic Content */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1
        }} className="relative z-10 text-center max-w-4xl px-4" data-id="element-667">
            <h1 className="mb-4 text-4xl md:text-6xl lg:text-[4.5rem] font-black leading-tight text-white tracking-tight drop-shadow-lg" data-id="element-668">
              {content.title1}
            </h1>
            <h2 className="mb-6 text-2xl md:text-3xl font-bold text-white/90 drop-shadow-md" data-id="element-669">
              {content.title2}
            </h2>
            <p className="text-base md:text-lg mb-8 text-gray-300 font-medium leading-relaxed max-w-2xl mx-auto drop-shadow-md" data-id="element-670">
              {content.sub}
            </p>
            <button onClick={() => setIsPopupOpen(true)} className="group inline-flex items-center justify-center gap-2 rounded-full px-10 py-4 font-bold text-lg transition-all hover:scale-105 bg-white/10 backdrop-blur-md border border-white/30 text-white hover:bg-white/20" data-id="element-671">
              {content.cta}
              <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-672" />
            </button>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-673" />
    </>;
}